var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"screen",staticClass:"td-screen"},[_c('div',{ref:"screenOpera",staticClass:"oprea"},[_vm._t("oprea")],2),_c('div',{ref:"screenRight",staticClass:"search"},[_vm._t("right")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }